module.exports = __webpack_public_path__ + "img/Nyromantikk_og_det_ubevisste_sjaeleliv.faff91bd.jpg";